import classNames from 'classnames';
import AntModal, { ModalFuncProps as AntModalFuncProps } from 'antd/lib/modal';

import styles from './ModalConfirm.module.scss';
export interface ModalConfirmProps extends AntModalFuncProps {
	theme?: string;
}

const modalConfirm = (props: ModalConfirmProps) => {
	const { theme, ...restProps } = props;
	return AntModal.confirm({
		...restProps,
		autoFocusButton: props.autoFocusButton || null,
		centered: true,
		className: classNames(styles.modalConfirm, props.className, {
			[styles[`modalConfirm-${theme}`]]: theme !== '',
		}),
	});
};

export default modalConfirm;
